import { Badge, Box, Chip, TableCell } from "@mui/material";
import StyledTableRow from "../../../../components/table/styled-table-row";
import { Product, ProductBatchRequest, ProductRequest } from "../../../../service/model/store.model";
import { ReactNode, useState } from "react";
import ProductForm from "./product-form";
import { ConfirmationDialog } from "../../../../components/confiramation-dialog";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import { deleteProduct, updateProduct } from "../product.slice";
import { selectLoggedInUser } from "../../../auth/auth.slice";
import TableActionButton from "../../../../components/table/table-action-button";
import ProductBatchForm from "../../product-batch/components/product-batch-form";
import { createBatch } from "../../product-batch/product-batch.slice";
import ProductBatchModal from "../../product-batch/components/product-batch-modal";
import { getCurrentDate } from "../../../../shared/utils";
import { CreateNewFolderIcon, DeleteIcon, EditIcon, ViewColumnIcon } from "../../../../shared/icons";

interface TableRowProps {
    readonly product: Product
}

const ProductTableRow: React.FC<TableRowProps> = ({ product }) => {
    const dispatch = useAppDispatch();
    const [showDeleteDialog, setShowDeleteDialog] = useState(false);
    const [showProductForm, setShowProductForm] = useState(false);
    const [showProductBatchForm, setShowProductBatchForm] = useState(false);
    const [showBatchModal, setShowBatchModal] = useState(false);
    const loggedInUserDetails = useAppSelector(selectLoggedInUser);
    const loggedInUser = loggedInUserDetails?.user;

    const handleDelete = () => {
        dispatch(deleteProduct(product.id))
        setShowDeleteDialog(false)
    }

    const handleDeleteCancel = () => {
        setShowDeleteDialog(false)
    }

    const handleSubmit = (data: ProductRequest) => {
        loggedInUser && dispatch(updateProduct({ ...data, id: product.id })).then(resp => {
            if (resp.meta.requestStatus === 'fulfilled') {
                setShowProductForm(false);
            }
        });
    };

    const handleSubmitBatch = (data: ProductBatchRequest) => {
        data.productId = product.id;
        loggedInUser && dispatch(createBatch({ ...data})).then(resp => {
            if (resp.meta.requestStatus === 'fulfilled') {
                setShowProductBatchForm(false);
            }
        });
    };

    const getStockBadgeColor = (totalStock: number, lowStockThreshold: number) => {
        if (totalStock <= 0) return 'error';
        else if (totalStock <= lowStockThreshold) return 'warning';
        else return 'success';
    }

    const getStockBadge = (totalStock: number, lowStockThreshold: number): ReactNode => {
        return <Chip label={totalStock} color={getStockBadgeColor(totalStock, lowStockThreshold)} />
    }

    return (
        <>
            <StyledTableRow key={product.id}>
                <TableCell><Box component="div" display="inline" className="responsive-mobile-heading">Name</Box>{product.name}</TableCell>
                <TableCell><Box component="div" display="inline" className="responsive-mobile-heading">Description</Box>{product.description}</TableCell>
                <TableCell><Box component="div" display="inline" className="responsive-mobile-heading">Stock Available</Box>{getStockBadge(product.totalStock, product.lowStockThreshold)}</TableCell>
                <TableCell><Box component="div" display="inline" className="responsive-mobile-heading">Low Stock Threshold</Box>{product.lowStockThreshold}</TableCell>
                <TableCell>
                    <Box component="div" display="inline" className="responsive-mobile-heading">Actions</Box>
                    <TableActionButton onClick={() => setShowProductForm(true)} label="Edit" icon={<EditIcon />} />
                    <TableActionButton onClick={() => setShowBatchModal(true)} label="Manage Batch Data" icon={<Badge badgeContent={product.batches.filter(b => b.expiryDate < getCurrentDate()).length} color="error"><ViewColumnIcon /></Badge>} />
                    <TableActionButton onClick={() => setShowProductBatchForm(true)} label="Add New Batch" icon={<CreateNewFolderIcon />} />
                    <TableActionButton onClick={() => setShowDeleteDialog(true)} label="Delete" icon={<DeleteIcon />} />
                </TableCell>
            </StyledTableRow>
            {showProductForm &&
                <ProductForm product={product} editable={true} onClose={() => setShowProductForm(false)} onSubmit={handleSubmit} />
            }
            {showProductBatchForm &&
                <ProductBatchForm editable={true} onClose={() => setShowProductBatchForm(false)} onSubmit={handleSubmitBatch}  />
            }
            {showBatchModal &&
                <ProductBatchModal productId={product.id} onClose={() => setShowBatchModal(false)}/>
            }
            {showDeleteDialog &&
                <ConfirmationDialog show={true} message="Are you sure you want to delete?" onConfirm={handleDelete} onCancel={handleDeleteCancel} />
            }
        </>
    );
}

export default ProductTableRow;